import { setupWorker } from 'msw/browser';
import { authHandlers } from './handlers/auth';
import { landsHandlers } from './handlers/lands';
import { farmingHandlers } from './handlers/farming';
import { processingHandlers } from './handlers/processing';
import { traceCodeHandlers } from './handlers/traceCode';
import { systemHandlers } from './handlers/system';
import { notarizationHandlers } from './handlers/notarization';

export const worker = setupWorker(
  ...authHandlers,
  ...landsHandlers,
  ...farmingHandlers,
  ...processingHandlers,
  ...traceCodeHandlers,
  ...systemHandlers,
  ...notarizationHandlers,
);

export async function enableMocking() {
  // 与 main.ts 保持一致：仅当 VITE_ENABLE_MOCK 显式设为 'true' 时才启用 Mock
  if (import.meta.env.VITE_ENABLE_MOCK !== 'true') {
    return;
  }

  // Start MSW service worker in browser
  return worker.start({
    onUnhandledRequest: 'bypass',
    serviceWorker: {
      url: '/mockServiceWorker.js',
    },
  }).catch((err) => {
    // If service worker registration fails in some browser environments, fallback gracefully
    console.warn('MSW Worker start failed, continuing with direct fallback:', err);
  });
}
